/**
 * Perfume Bundle Builder — vanilla JS, no jQuery, no external libraries.
 * Handles: qty steppers per bundle panel, max-quantity enforcement,
 * sticky summary, button ripple, fade-in on scroll, and adding every
 * selected variant to the cart via /cart/add.js.
 */
(function () {
  'use strict';

  function initRoot(root) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pbb-panel]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pbb-tab]'));
    var summary = root.querySelector('[data-pbb-summary]');
    var summaryTitle = root.querySelector('[data-pbb-summary-title]');
    var countEl = root.querySelector('[data-pbb-count]');
    var maxEl = root.querySelector('[data-pbb-max]');
    var priceEl = root.querySelector('[data-pbb-price]');
    var addBtn = root.querySelector('[data-pbb-add]');
    var addLabel = root.querySelector('[data-pbb-add-label]');

    if (!panels.length || !addBtn) return;

    // state[panelIndex] = { productId: { variantId, qty, el } }
    var state = {};
    panels.forEach(function (panel) {
      state[panel.getAttribute('data-pbb-panel')] = {};
    });

    var activeIndex = panels.length ? panels[0].getAttribute('data-pbb-panel') : '0';

    function activePanel() {
      return panels.filter(function (p) {
        return p.getAttribute('data-pbb-panel') === activeIndex;
      })[0];
    }

    function totalQty(index) {
      var entries = state[index] || {};
      var total = 0;
      Object.keys(entries).forEach(function (key) {
        total += entries[key].qty;
      });
      return total;
    }

    function updateCardButtons(panel) {
      var index = panel.getAttribute('data-pbb-panel');
      var max = parseInt(panel.getAttribute('data-max'), 10) || 0;
      var total = totalQty(index);
      var atMax = total >= max;

      Array.prototype.forEach.call(panel.querySelectorAll('[data-pbb-card]'), function (card) {
        var plusBtn = card.querySelector('[data-action="plus"]');
        var minusBtn = card.querySelector('[data-action="minus"]');
        var qtyEl = card.querySelector('[data-qty]');
        var qty = parseInt(qtyEl.textContent, 10) || 0;

        if (plusBtn) plusBtn.disabled = atMax;
        if (minusBtn) minusBtn.disabled = qty <= 0;
        card.classList.toggle('is-selected', qty > 0);
      });
    }

    function updateSummary() {
      var panel = activePanel();
      if (!panel) return;

      var max = parseInt(panel.getAttribute('data-max'), 10) || 0;
      var price = panel.getAttribute('data-price') || '0';
      var title = panel.getAttribute('data-title') || '';
      var total = totalQty(activeIndex);

      if (summaryTitle) summaryTitle.textContent = title;
      if (countEl) countEl.textContent = total;
      if (maxEl) maxEl.textContent = max;
      if (priceEl) priceEl.textContent = '\u20B9' + price;

      addBtn.disabled = total !== max;

      if (summary) {
        summary.classList.toggle('is-visible', total > 0);
      }
    }

    function bumpQty(el) {
      el.classList.remove('is-bumped');
      // force reflow so the animation can restart
      void el.offsetWidth;
      el.classList.add('is-bumped');
    }

    function handleQtyClick(e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;

      var card = btn.closest('[data-pbb-card]');
      var panel = btn.closest('[data-pbb-panel]');
      if (!card || !panel) return;

      var index = panel.getAttribute('data-pbb-panel');
      var max = parseInt(panel.getAttribute('data-max'), 10) || 0;
      var productId = card.getAttribute('data-product-id');
      var variantId = card.getAttribute('data-variant-id');
      var qtyEl = card.querySelector('[data-qty]');
      var qty = parseInt(qtyEl.textContent, 10) || 0;
      var action = btn.getAttribute('data-action');

      if (action === 'plus') {
        if (totalQty(index) >= max) return;
        qty += 1;
      } else if (action === 'minus') {
        if (qty <= 0) return;
        qty -= 1;
      }

      qtyEl.textContent = qty;
      bumpQty(qtyEl);

      if (!state[index]) state[index] = {};
      if (qty > 0) {
        state[index][productId] = { variantId: variantId, qty: qty };
      } else {
        delete state[index][productId];
      }

      updateCardButtons(panel);
      updateSummary();
    }

    function switchTab(newIndex) {
      activeIndex = newIndex;

      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-pbb-tab') === newIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-pbb-panel') === newIndex);
      });

      updateSummary();
    }

    function createRipple(e, btn) {
      var rect = btn.getBoundingClientRect();
      var ripple = document.createElement('span');
      var size = Math.max(rect.width, rect.height);
      ripple.className = 'pbb-ripple';
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
      ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
      btn.appendChild(ripple);
      window.setTimeout(function () {
        ripple.remove();
      }, 650);
    }

    function addBundleToCart() {
      var entries = state[activeIndex] || {};
      var items = Object.keys(entries).map(function (productId) {
        return {
          id: parseInt(entries[productId].variantId, 10),
          quantity: entries[productId].qty
        };
      });

      if (!items.length) return;

      addBtn.disabled = true;
      var originalLabel = addLabel ? addLabel.textContent : '';
      if (addLabel) addLabel.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error((err && err.description) || 'Could not add bundle to cart');
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          if (addLabel) addLabel.textContent = originalLabel;
          addBtn.disabled = false;
          window.console && console.error('Perfume bundle builder:', err);
          window.alert('Something went wrong adding the bundle to your cart. Please try again.');
        });
    }

    // Event delegation: quantity buttons
    panels.forEach(function (panel) {
      panel.addEventListener('click', handleQtyClick);
    });

    // Tabs
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTab(tab.getAttribute('data-pbb-tab'));
      });
    });

    // Add to cart + ripple
    addBtn.addEventListener('click', function (e) {
      if (addBtn.disabled) return;
      createRipple(e, addBtn);
      addBundleToCart();
    });

    // Fade-in on scroll
    var fadeEls = Array.prototype.slice.call(root.querySelectorAll('.pbb-fade-in'));
    if ('IntersectionObserver' in window && fadeEls.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );
      fadeEls.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      fadeEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    // Initial paint
    panels.forEach(updateCardButtons);
    updateSummary();
  }

  function init() {
    var roots = document.querySelectorAll('[data-pbb-root]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('[data-pbb-root]');
    if (root) initRoot(root);
  });
})();
